import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PopupDetailsRes;
export const PopupDetailsTodo = createAsyncThunk('PopupDetails', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `popup_data/${id}`,
            params:{
                "status": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return PopupDetailsRes = res.data

    } catch (error) {
        return PopupDetailsRes = error.response.data
    }
})

const PopupDetailsSlice = createSlice({
    name: 'PopupDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PopupDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(PopupDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PopupDetailsSlice.reducer; 